import { useState, useEffect } from "react";

import useAPI from "../../helperHooks/useAPI";
import useSessionStorage from "../../helperHooks/useSessionStorage";

import sessionStorage from "../../services/SessionStorage";
import SessionStorageKeys from "constants/SessionStorageConstants";
import { DownloadService } from "../../services/downloadService";
import { DownloadServiceResponse } from "../../services/downloadService/DownloadService.type";

interface NameAndImage {
  userName: string;
  imageUrl?: string;
}

const useNameAndImage: (fetchImage?: boolean) => NameAndImage = fetchImage => {
  const [imageUrl, setImageUrl] = useState<string>();
  const [profileImgS3Key] = useSessionStorage<string>(
    SessionStorageKeys.ProfileImageKey,
    ""
  );

  const { callAPI: downloadDocument } = useAPI(
    DownloadService.downloadEligibilityDocument
  );

  const userName = sessionStorage.getItem(SessionStorageKeys.Username) || "";

  useEffect(() => {
    if (fetchImage && profileImgS3Key) {
      downloadDocument(
        profileImgS3Key,
        (downloadReponse?: DownloadServiceResponse) => {
          setImageUrl(downloadReponse?.downloadUrl);
        }
      );
    }
  }, [fetchImage, profileImgS3Key, downloadDocument]);

  return { userName, imageUrl };
};

export default useNameAndImage;
